/**
 * The rule a new password has to meet, stated once.
 *
 * Sign-up and password reset both choose a password, and Cognito holds both to
 * the same pool policy. Two copies of the rule would be two places to update
 * when the policy changes, and the one that was missed would accept a password
 * the pool then refuses.
 *
 * MIRRORS THE USER POOL, AND USED NOT TO. Sign-up asked for eight characters
 * while Cognito's policy required twelve plus four character classes, so the
 * form accepted a password, submitted it, and the pool refused it -- surfacing
 * as a 500 and "Sign-up is unavailable". The authority is
 * infra/terraform/modules/auth: var.password_minimum_length and the
 * password_policy block on aws_cognito_user_pool. Changing either means
 * changing this.
 */

import { z } from 'zod'

export const NEW_PASSWORD_HINT =
  'At least 12 characters, with an uppercase letter, a lowercase letter, a number and a symbol.'

export const newPasswordSchema = z.string()
  .min(12, 'Use at least 12 characters.')
  .regex(/[a-z]/, 'Include a lowercase letter.')
  .regex(/[A-Z]/, 'Include an uppercase letter.')
  .regex(/[0-9]/, 'Include a number.')
  .regex(/[^A-Za-z0-9]/, 'Include a symbol, such as ! or ?.')
